export const userColumns = [
  {
    field: "username",
    headerName: "User",
    width: 170,
  },
  {
    field: "email",
    headerName: "Email",
    width: 150,
  },
  {
    field: "number",
    headerName: "Number",
    width: 150,
  },
  {
    field: "Date",
    headerName: "Date",
    width: 150,
  },
  {
    field: "category",
    headerName: "Category",
    width: 150,
  },
  {
    field: "service",
    headerName: "Service",
    width: 150,
  },
  {
    field: "branch_name",
    headerName: "Branch",
    width: 150,
  },
  {
    field: "location",
    headerName: "Branch Location",
    width: 150,
  },
  {
    field: "demo_status",
    headerName: "demo_status",
    width: 150,
  },
  // {
  //   field: "to",
  //   headerName: "Start Date",
  //   width: 230,
  // },
  // {
  //   field: "from",
  //   headerName: "End Date",
  //   width: 230,
  // },
];
